import RelationsPage from './list';

export default RelationsPage;
